import { Injectable, inject } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Observable, map } from 'rxjs';
import { SvcDialogService } from '@solvace/component/svc-dialogs';
import { SvzDialogService } from '@solvace/zard/svz-dialogs/svz-dialog.service';

export const DELETE_ALERT_QUESTION = 'Tem certeza que deseja remover este alerta?';

type ConfirmConfig = Parameters<SvcDialogService['openConfirm']>[1];

@Injectable()
export class AlertRecordDialogService extends SvcDialogService {
  private readonly svzDialog = inject(SvzDialogService);
  private readonly transloco = inject(TranslocoService);

  public override openConfirm(text: string, config?: ConfirmConfig): Observable<boolean> {
    if (text !== DELETE_ALERT_QUESTION) return super.openConfirm(text, config);

    return this.svzDialog
      .openConfirm(this.transloco.translate('Esta ação não pode ser desfeita.'), {
        variant: 'design-system',
        title: this.transloco.translate('Tem certeza que deseja excluir?'),
        okText: this.transloco.translate('Excluir'),
        cancelText: this.transloco.translate('Cancelar'),
      })
      .pipe(map(Boolean));
  }
}
